export default function registerStore(Store, Dispatcher, handlers) {
  const S = Store;
  S.dispatchToken = Dispatcher.register((payload) => {
    const action = payload.action;
    const type = action.type;
    const handler = handlers[type];
    if (typeof handler === 'function') {
      handler(action);
    } else if (handler) {
      Store[handler](action);
    }
  });
}
